export default class PublishSolutionHandlerError extends Error {
}
